import { CommonModule } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { BadgeComponent, InfoCardComponent } from '@webapp/ui';
import { formatDNI } from '@webapp/core';
import { CuitPipe } from '@webapp/core/pipes/cuit.pipe';
import { IUser, IUserDetail, USER_TYPES } from '../../../interfaces/users.interface';
import { AuthService } from '@webapp/auth/services/auth.service';
import { ShowForRoleDirective } from '@webapp/core/directives/showForRole';

@Component({
  selector: 'app-user-info',
  imports: [CommonModule, BadgeComponent, InfoCardComponent, ShowForRoleDirective],
  providers: [CuitPipe],
  templateUrl: './user-info.component.html',
  styleUrl: './user-info.component.scss',
})
export class UserInfoComponent {
  user = input.required<IUserDetail>();

  authService = inject(AuthService);
  private readonly cuitPipe = inject(CuitPipe);

  edit = output<{ user: Pick<IUser, 'firstName' | 'lastName'> }>();

  isSuperAdmin(): boolean {
    const currentUser = this.authService.user();
    return currentUser?.type === 'superadmin';
  }

  formatIdentification(user: IUserDetail): string {
    if (!user.identification) return '';
    return user.type === USER_TYPES.PERSON
      ? formatDNI(user.identification) ?? ''
      : this.cuitPipe.transform(user.identification) ?? '';
  }

  onEdit() {
    const agent = this.user().agent;
    if (agent) {
      this.edit.emit(agent);
    }
  }
}
